export default __webpack_public_path__ + "static/media/white_invoice_icon.2932b30b.svg";